<template>
  <div class="g-myToDo">
    <div class="myToDo-menus">
      <div class="myToDo-title">
        <el-radio-group v-model="messageType" size="mini" class="top-radio">
          <el-radio-button label="3">待办</el-radio-button>
          <el-radio-button label="1">消息</el-radio-button>
        </el-radio-group>
      </div>
      <div v-if="menuList&&menuList.length>0">
        <div
          v-for="(item, i) in menuList"
          :key="i"
          class="menus-item"
          :class="appUuid == item.appUuid ? 'checkItem' : ''"
          @click="appUuid = item.appUuid"
        >
          <div class="item-icon">
            <img v-if="item.appIconUrl" :src="item.appIconUrl" alt="">
            <img v-else src="~@/assets/myToDo/allToDo@2x.png" alt="">
          </div>

          <UmToolTip :content="item.appName" class="row_1 item-name" />
          <div class="item-num">
            {{ item.unProcessCount >99?'99+':item.unProcessCount }}
          </div>
        </div>
      </div>
      <div v-else class="m-noData centerData ">
        暂无数据
      </div>
    </div>

    <el-card class="myToDo-event">
      <div class="myToDo-title f-p0">
        <div class="title-icon" />
        {{ messageType=='3'?'待办事项':'消息事项' }}
      </div>
      <div class="event-top">
        <el-radio-group v-show="messageType=='3'" v-model="readState" size="mini" class="top-radio">
          <el-radio-button label="0">待办（{{ stateCount.unProcessCount }}）</el-radio-button>
          <el-radio-button label="2">已逾期（{{ stateCount.overdueCount }}）</el-radio-button>
          <el-radio-button label="1">已办（{{ stateCount.alreadyProcessCount }}）</el-radio-button>
        </el-radio-group>
        <el-radio-group v-show="messageType=='1'" v-model="readState" size="mini" class="top-radio">
          <el-radio-button label="0">未读（{{ stateCount.unProcessCount }})</el-radio-button>
          <el-radio-button label="1">已读（{{ stateCount.alreadyProcessCount }}）</el-radio-button>
        </el-radio-group>
        <el-popover
          v-if="readState != 1"
          placement="bottom-end"
          width="108"
          trigger="click"
          :visible-arrow="false"
          class="top-sort"
          popper-class="m_enterpris_popover"
        >
          <div class="sort-check">
            <div
              class="check-item"
              :class="sortType == 1 ? 'check' : ''"
              @click="sortType = 1"
            >
              按最近创建时间
            </div>
            <div
              class="check-item"
              :class="sortType == 2 ? 'check' : ''"
              @click="sortType = 2"
            >
              按最近截止时间
            </div>
          </div>
          <div slot="reference" class="sort-btn f-flex-ac">
            <div class="btn-icon" />
            排序
          </div>
        </el-popover>
      </div>
      <div v-if="toDoList&&toDoList.length>0" class="event-content">
        <div v-for="(item, i) in toDoList" :key="i" class="content-item" @click="goUrl(item)">
          <div class="item-title f-flex-ac">
            <div class="title-icon">
              <img :src="item.appIconUrl" alt="">
            </div>
            <span>  {{ item.appName||'--' }}</span>

            <span v-if="!item.readStatus" class="m-icon-time-icon" />
          </div>
          <div class="item-information f-flex-acjcsb">
            <div class="information-content">
              <UmToolTip :content="item.title" class="row_1" />
            </div>
            <div class="information-time">{{ item.createTime }}</div>
          </div>
          <div class="item-remark" :class="readState == 1?'f-pd-b16':''">
            <UmToolTip :content="item.content" class="row_1 " />
          </div>
          <div v-if="readState != 1" class="item-bottom f-flex-acjcsb">
            <div class="bottom-time f-flex-ac">
              <div v-if="item.overTime">截止时间：{{ item.overTime||'--' }}</div>
              <div v-if="item.isOver" class="time-overdue">逾期{{ getOverTime(item.overTime) }}</div>
            </div>
            <div v-if="item.pcRedirect" class="bottom-see f-flex-ac">查看详情<div class="see-icon" /> </div>
          </div>
        </div>
        <div>
          <pagination
            :background="false"
            :limit.sync="page.pageSize"
            :page.sync="page.pageNum"
            :total="tableTotal"
            @pagination="getList('page')"
          />
        </div>
      </div>
      <div v-else class="m-noData centerData">
        暂无数据
      </div>
    </el-card>
    <AppQrcode :isapp-uuid="isappUuid" :invitation.sync="invitation" @changevisible="changevisible" />
  </div>
</template>
<script>
import { jumpUrl } from '@/utils/backlog'
import {
  getDoneToRead,
  todoSAelectUnProcessCount,
  pendingMessageSelectUnProcessCount, messageUpdateBatchReadStatus, todoUpdateBatchReadStatus
} from '@/api/myToDo'
import AppQrcode from '@/layout/appQrcode'
import { pendingMessagePtPageList, todoPtPageList } from '@/api/workbench'
export default {
  name: 'MyToDo',
  components: { AppQrcode },
  data() {
    return {
      messageType: '3',
      jumpUrl,
      appUuid: '',
      menuList: [],
      readState: '0',
      sortType: 1,
      toDoList: [],
      tableTotal: 0,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      stateCount: {
        alreadyProcessCount: 0, // 已处理数量
        unProcessCount: 0, // 未处理数量
        overdueCount: 0 // 逾期数量
      },
      isappUuid: '',
      invitation: false
    }
  },
  watch: {
    readState(val) {
      if (val) {
        this.getList()
      }
    },
    sortType(val) {
      if (val) {
        this.getList()
      }
    },
    appUuid() {
      this.getList()
    },
    messageType(val) {
      if (val) {
        this.getGroup()
        this.appUuid = ''
        if (val === '1' && this.readState === '2') {
          this.readState = '0'
          return
        }
        this.getList()
      }
    },
    $route: {
      handler(val) {
        this.messageType = val.query.type || '3'
      }
    }
  },
  created() {
    this.messageType = this.$route.query.type || '3'
    this.getGroup()
    this.getList()
  },
  methods: {
    // 列表
    getList(state = '') {
      if (state != 'page') {
        this.page.pageNum = 1
      }
      const todoParams = {
        transactStatus: this.readState, // 办理状态（0：未办，1：已办，2：逾期）
        appUuid: this.appUuid, // 应用UUID
        sortType: this.sortType, // 排序类型: 1. 按最近创建时间 2. 按最近截止时间
        needStatusCount: true, // 是否需要统计不同状态下的数量
        dailyGroupFlag: false, // 是否需要按照时间维度分组
        page: this.page
      }
      const messageParams = {
        readStatus: this.readState, // 读取状态（0：未读，1：已读）
        appUuid: this.appUuid, // 应用UUID
        needStatusCount: true, // 是否需要统计不同状态下的数量
        dailyGroupFlag: false, // 是否需要按照时间维度分组
        page: this.page
      }
      const params = this.messageType === '1' ? messageParams : todoParams
      const load = this.$load()
      const Api = this.messageType === '1' ? pendingMessagePtPageList : this.messageType === '3' ? todoPtPageList : null
      if (Api) {
        Api(params).then(res => {
          let arr = []
          if (res.data.list.length > 0) {
            res.data.list.forEach(item => {
              arr = arr.concat(this.messageType === '1' ? item.pendingList : item.todoList)
            })
            this.toDoList = arr
          } else {
            this.toDoList = []
          }

          this.tableTotal = res.data.page.total
          if (res.data.stateCount) {
            this.stateCount = res.data.stateCount
          }
          load.close()
        }).catch(() => {
          load.close()
        })
      } else {
        this.toDoList = []
      }
    },
    // app分组
    getGroup() {
      const Api = this.messageType == '3' ? todoSAelectUnProcessCount : pendingMessageSelectUnProcessCount
      const params = {
        sumFlag: true
      }
      Api(params).then(res => {
        this.menuList = res.data
      })
    },
    // 消息已读
    async getReady(item) {
      try {
        const Api = this.messageType === '1' ? messageUpdateBatchReadStatus : todoUpdateBatchReadStatus
        const res = Api({ idList: [item.id], appUuid: item.appUuid })
      } catch (e) {
        console.log(e)
      }
    },
    getOverTime(time) {
      const nowTime = new Date().getTime()
      const overTime = new Date(time).getTime()
      let num = null
      if (nowTime < overTime) {
        console.log('没逾期')
      } else {
        num = parseInt((nowTime - overTime) / 1000 / 60 / 60)
        if (num > 24) {
          return parseInt((num / 24)) + '天'
        } else {
          return num + '小时'
        }
      }
    },
    async goUrl(item) {
      if (item.readStatus === 0) {
        await this.getReady(item)
      }
      if (item.urlScope == 1 || (item.urlScope == 3 && !item.pcRedirect)) {
        this.invitation = true
        this.isappUuid = item.appUuid
      } else {
        this.jumpUrl(item.pcRedirect)
        // this.getList()
      }
    },
    changevisible(val) {
      this.invitation = val
    }
  }
}
</script>
<style lang="scss" scoped>
.m_sort_popover {
  padding: 0;
  width: 108px;
}
.sort-check {
  text-align: center;
}
.check-item {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #6c7b96;
  background: #ffffff;
  cursor: pointer;

  &.check {
    background: rgba(76, 100, 254, 0.1);
    color: #4c64fe;
    &:first-child {
      border-radius: 4px 4px 0 0;
    }
    &:last-child {
      border-radius: 0 0 4px 4px;
    }
  }
}
</style>
